<div class="hint-top-right"><a href="/tng">Zum neuen Design wechseln</a></div>
<mat-drawer-container autosize>
  <mat-drawer #drawer mode="side" class="navigation" opened style="position: fixed">

    <button class="hamburger hamburger--slider hide-on-desktop" [class.is-active]="drawer.opened" type="button"
            (click)="drawer.toggle()">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
    </button>

    <div class="header-logo">
      <img src="assets/logo-minimal.svg" style="height: 1.6em; margin-top: 25px"/>
    </div>

    <div class="welcome">
      <span>Willkommen</span><br/>
      <div *ngIf="user?.name" class="user-name">{{user?.name}}</div>
    </div>
    <mat-selection-list [multiple]="false">
      <mat-list-option routerLink="/transition" (click)="menuItemClicked()" [selected]="!isActive('tools')">
        <mat-icon mat-list-icon svgIcon="lead_form"></mat-icon>
        Kunden überleiten
      </mat-list-option>
      <mat-list-option routerLink="/tools" (click)="menuItemClicked()" [selected]="isActive('tools')">
        <mat-icon mat-list-icon svgIcon="tools"></mat-icon>
        Rechner & Tools
      </mat-list-option>
      <mat-list-option routerLink="/content-modules" (click)="menuItemClicked()"
                       [selected]="isActive('content-modules')">
        <mat-icon mat-list-icon svgIcon="plus"></mat-icon>
        Inhalte Homepage
      </mat-list-option>
      <mat-list-option routerLink="/history" (click)="menuItemClicked()" [selected]="isActive('history')">
        <mat-icon mat-list-icon svgIcon="history"></mat-icon>
        Historie
      </mat-list-option>
      <div class="separator"></div>
      <mat-list-option routerLink="/support" (click)="menuItemClicked()" [selected]="isActive('support')">
        <mat-icon mat-list-icon svgIcon="support"></mat-icon>
        Support
      </mat-list-option>
      <mat-list-option (click)="passwordChange()">
        <mat-icon mat-list-icon svgIcon="change_password"></mat-icon>
        Passwort ändern
      </mat-list-option>
    </mat-selection-list>
    <button class="logout" mat-stroked-button color="primary" (click)="logout()">Abmelden</button>

  </mat-drawer>

  <div class="wrapper">
    <button class="hamburger hamburger-padding hamburger--slider hide-on-desktop" [class.is-active]="drawer.opened" type="button"
            (click)="drawer.toggle()">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
    </button>
    <div class="background-img top-right-rectangle"></div>
    <div class="content">
      <div *ngIf="errorMessage; else showForm">
        <div class="text-center" style="font-size: larger">
          <p class="h2-no-line margin-top-7px">Vielen Dank für Ihre Registrierung zum Partnerportal.</p>
          <br/>
          Ihr Account ist noch nicht mit Ihren personalisierten Inhalten verknüpft.
          Klicken Sie dafür bitte zuerst in Ihrer Einladungsmail auf den Link "Zur Registrierung" und loggen sich erneut
          ein.
          <br/>
          <br/>
          Sie haben noch keine Einladungsmail erhalten oder Ihr Einladungslink ist abgelaufen? Dann wenden Sie sich gerne
          an:
          <br/>
          <br/>
          <br/>
          <br/>
        </div>

        <div class="display-flex-center">
          <div class="info-box">
            <div class="info-image">
              <img src="assets/support.svg" style="height: 112px;"/>
            </div>
            <div class="info-text">
              <h1 class="black">Dr. Klein B2B-Support</h1>
              <h4>First Level Support Partnerportal</h4>
              <table>
                <tr>
                  <td>
                    <mat-icon color="primary" style="vertical-align: middle; margin-right: 15px">location_on</mat-icon>
                  </td>
                  <td>
                    Hansestraße 14 <br/>
                    23558 Lübeck
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-icon color="primary" style="vertical-align: middle">mail</mat-icon>
                  </td>
                  <td>
                    <a href="mailto:plattform-support@drklein.de">plattform-support@drklein.de</a>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <ng-template #showForm>
        <router-outlet></router-outlet>
      </ng-template>
    </div>
    <div class="background-img bottom-left-rectangle"></div>
    <div class="background-img bottom-right-rectangle"></div>
  </div>
  <div class="footer">
    <a target="_blank" href="https://www.drklein.de/datenschutz.html">Datenschutz</a>
    &nbsp;·&nbsp;
    <a target="_blank" href="https://www.drklein.de/agb.html">AGB</a>
    &nbsp;·&nbsp;
    <a target="_blank" href="https://www.drklein.de/impressum.html">Impressum</a>
  </div>

</mat-drawer-container>
